// removed by extract-text-webpack-plugin
module.exports = {"hidden":"UJWrC","visuallyhidden":"_3gP0j","hide-text":"_2WoSY","center":"_3iGrV","noprint":"_2IUkS","root":"_1ZzPF","text":"_21O08"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-blockquote/styles/default.scss
 ** module id = 987
 ** module chunks = 2
 **/